import { RoleType } from '../types/Role.types';
import { isUserResearcherWithRelatedBiobankSteeringGroup } from './roles';

interface ApplicationLinkType {
  text: string;
  href: string;
}

export const nonAdminRoles = [
  'organisation-steering-group',
  'ethical-reviewer',
  'researcher',
  'expert',
] as const;

export const getAppLinksForRole = (
  userRoles: RoleType[],
  t: (arg0: string) => string
): ApplicationLinkType[] => {
  const applicationLinks: ApplicationLinkType[] = [];
  // if user is in a generic role, or researcher with related biobank steering group, show default links
  const showDefaultLinks =
    userRoles.every((role) => (nonAdminRoles as readonly string[]).includes(role)) ||
    isUserResearcherWithRelatedBiobankSteeringGroup(userRoles);

  if (showDefaultLinks) {
    (
      JSON.parse(
        process.env.REACT_APP_RESEARCHER_APPLICATION_LINKS || '[]'
      ) as ApplicationLinkType[]
    )
      .map((appLink) => ({ text: t(`ApplicationNames.${appLink.text}`), href: appLink.href }))
      .forEach((i) => {
        applicationLinks.push(i);
      });
  } else if (userRoles === undefined || userRoles.length === 0) {
    // No role, no links yet. Either user is not logged in, or not
    // approved. Only show the "Platform" link so the user knows where
    // they are.
    applicationLinks.push({
      text: t('ApplicationNames.platform') as string,
      href: process.env.REACT_APP_URL_PLATFORM as string,
    });
  } else {
    // "admin" level links
    (JSON.parse(process.env.REACT_APP_APPLICATION_LINKS || '[]') as ApplicationLinkType[])
      .map((appLink) => ({ text: t(`ApplicationNames.${appLink.text}`), href: appLink.href }))
      .forEach((i) => {
        applicationLinks.push(i);
      });
  }

  return applicationLinks;
};
